import request from "@/utils/request";

export function quickGetNews(category){
   return  request.post(`/newsinfo/quickGetNews`,{
       newsCategory:category
    })
}


export function listNewsAll(page,size,category){
    return request.post(`/newsinfo/listAll?page=${page}&size=${size}`,{
        newsCategory:category
    })
}

export function getById(id){
    return request.get('/newsinfo/getById',{
        params:{
            id
        }
    })
}